<template>
  <div class="wrapper">
    <div class="container details">
      <div class="row"><div class="col-md-10"><h1>Statistik väntetid</h1></div></div>
      <div class="row" style="margin-top: 30px;width:1170px;max-width:100%">
        <div class="col-md-1 switchMonth" style="text-align:center">
          <label style="margin-bottom: 10px">{{chosenDateSpan}}</label>
          <br/>
          <InputSwitch v-model="dateChecked" />
        </div>
        <div class="col-md-2">
          <label for="startDate">Från</label><br/>
          <Calendar id="startDate" v-model="startDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-2">
          <label for="endDate">Till</label><br/>
          <Calendar id="endDate" v-model="endDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-2">
          <label for="customers">Kund</label><br/>
          <Dropdown v-if="customers" v-model="selectedCustomer" :options="customers" style="width:100%" optionLabel="name" placeholder="Välj kund.." />
        </div>
        <div class="col-md-2">
          <label for="customers">Fordon</label><br/>
          <Dropdown v-if="trucks" v-model="selectedTruck" :options="trucks" style="width:100%" optionLabel="name" placeholder="Välj fordon.." />
        </div>
        <div class="col-md-2">
          <label for="cargoPlaces">Väntplats</label><br/>
          <Dropdown v-if="cargoPlaces" v-model="selectedcargoPlace" :options="cargoPlaces" style="width:100%" optionLabel="name" placeholder="Välj plats.." />
        </div>
        <div class="col-md-1">
          <br/>
          <Button label="Sök" @click="getOrders()" />
        </div>
        <div class="col-md-1">
            <ProgressSpinner v-if="loading" style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s" />
        </div>
      </div>
      <div class="row mt-4" v-if="ordersWithWait">
        <div class="col-md-12">
            <DataTable :value="ordersWithWait" :selection.sync="selectedOrders" dataKey="id">
                <Column selectionMode="multiple" :headerStyle="{'width': '3em'}"></Column>
                <Column field="orderId" header="Order" footerStyle="text-align:left"></Column>
                <Column field="startWait" header="Start"></Column>
                <Column field="endWait" header="Slut"></Column>
                <Column field="driver" header="Chaufför"></Column>
                <Column field="truck" header="Fordon"></Column>
                <Column field="comment" header="Kommentar"></Column>
                <Column field="place" header="Plats"></Column>
                <Column header="Totalt" bodyStyle="text-align:right" footerStyle="text-align:right">
                  <template #body="slotProps" >{{getTotalWait(slotProps.data.startWait, slotProps.data.endWait)}}</template>
                  <template #footer>
                    {{totalTime}}
                    <span v-if="selectedOrders"><br/>{{getSelectedTotal()}} markerat</span>
                  </template>
                </Column>
            </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Row from 'primevue/row'
import ColumnGroup from 'primevue/columngroup'
import Button from 'primevue/button'
import moment from 'moment'
import Calendar from 'primevue/calendar'
import InputSwitch from 'primevue/inputswitch'
import Chart from 'primevue/chart'
import Dropdown from 'primevue/dropdown'
import ProgressSpinner from 'primevue/progressspinner'
export default {
  name: 'WaitStats',
  components: {
    DataTable,
    Column,
    Button,
    moment,
    ColumnGroup,
    Calendar,
    InputSwitch,
    Chart,
    Row,
    ProgressSpinner,
    Dropdown
  },
  data () {
    return {
      dateChecked: false,
      chosenDateSpan: 'År',
      startDate: null,
      endDate: null,
      selectedCustomer: null,
      selectedcargoPlace: null,
      selectedOrders: null,
      selectedTruck: null,
      totalMins: 0,
      trucks: [],
      customers: [],
      cargoPlaces: [],
      orders: [],
      loading: false,
      ordersWithWait: [],
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      }
    }
  },
  async mounted () {
    this.setOneYear()
    await this.getCargoPlaces()
    await this.getCustomers()
    await this.getTrucks()
  },
  computed: {
    totalTime: function () {
      return this.getTotalTime(this.totalMins)
    }
  },
  watch: {
    orders: function (newVal, oldVal) {
      this.orders = newVal
    },
    ordersWithWait: function (newVal, oldVal) {
      this.ordersWithWait = newVal
    },
    dateChecked: function (newVal, oldVal) {
      if (this.dateChecked) {
        this.chosenDateSpan = 'Månad'
        this.setMonth()
      } else {
        this.chosenDateSpan = 'År'
        this.setOneYear()
      }
    }
  },
  methods: {
    async getCustomers () {
      this.$http
        .get('/api/customers')
        .then(response => {
          var customers = response.data.customers
          this.customers.push({'id': null, 'name': 'Alla'})
          for (var i = 0; i < customers.length; i++) {
            this.customers.push({'id': customers[i].id, 'name': customers[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    async getCargoPlaces () {
      this.$http
        .get('/api/objectdatas/objectdescriptionid/24')
        .then(response => {
          let cargoPlaces = response.data
          this.cargoPlaces.push({'id': null, 'name': 'Alla'})
          for (var i = 0; i < cargoPlaces.length; i++) {
            this.cargoPlaces.push({'id': cargoPlaces[i].id, 'name': cargoPlaces[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    async getTrucks () {
      this.$http
        .get('/api/objectdatas/objectgroupid/2')
        .then(response => {
          let trucks = response.data
          this.trucks.push({'id': null, 'name': 'Alla'})
          trucks.sort(this.sortByName)
          for (var i = 0; i < trucks.length; i++) {
            this.trucks.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr})
          }
        })
        .catch(error => console.log(error))
    },
    async getOrders () {
      this.loading = true
      this.totalMins = 0
      this.ordersWithWait = []
      let startDate = moment(this.startDate).format('YYYY-MM-DD')
      let endDate = moment(this.endDate).format('YYYY-MM-DD')
      let customerId = this.selectedCustomer !== null ? this.selectedCustomer.id : null
      let callApi = '/api/orders/by-customer-hydro/' + customerId + '/by-daterange/between/' + startDate + '/' + endDate
      await this.$http
        .get(callApi)
        .then(response => {
          this.orders = response.data
          for (let order of this.orders) {
            for (let orderRow of order.data.orderRows) {
              for (let action of orderRow.actions) {
                if (action.name === 'Väntetid') {
                  if ((this.selectedcargoPlace === null || this.selectedcargoPlace.id === null) && (this.selectedTruck === null || this.selectedTruck.id === null)) {
                    this.ordersWithWait.push({id: action.id, orderId: order.id, startWait: action.startTime, endWait: action.endTime, driver: orderRow.driverName, truck: orderRow.truckName, place: action.cargoPlace, comment: action.comment})
                    this.setTotalMins(action.startTime, action.endTime)
                  } else if ((this.selectedcargoPlace !== null && this.selectedcargoPlace.name === action.cargoPlace) && (this.selectedTruck === null || this.selectedTruck.id === null)) {
                    this.ordersWithWait.push({id: action.id, orderId: order.id, startWait: action.startTime, endWait: action.endTime, driver: orderRow.driverName, truck: orderRow.truckName, place: action.cargoPlace, comment: action.comment})
                    this.setTotalMins(action.startTime, action.endTime)
                  } else if (this.selectedTruck !== null && this.selectedTruck.name === orderRow.truckName && this.selectedcargoPlace === null) {
                    this.ordersWithWait.push({id: action.id, orderId: order.id, startWait: action.startTime, endWait: action.endTime, driver: orderRow.driverName, truck: orderRow.truckName, place: action.cargoPlace, comment: action.comment})
                    this.setTotalMins(action.startTime, action.endTime)
                  } else if (this.selectedcargoPlace !== null && this.selectedcargoPlace.name === action.cargoPlace && this.selectedTruck.name === orderRow.truckName) {
                    this.ordersWithWait.push({id: action.id, orderId: order.id, startWait: action.startTime, endWait: action.endTime, driver: orderRow.driverName, truck: orderRow.truckName, place: action.cargoPlace, comment: action.comment})
                    this.setTotalMins(action.startTime, action.endTime)
                  }
                }
              }
            }
          }
          this.loading = false
          this.orders = response.data
        })
    },
    setOneYear () {
      let today = new Date()
      this.endDate = new Date()
      let oneYearBack = new Date(today.setDate(today.getDate() - 365))
      this.startDate = oneYearBack
    },
    setMonth () {
      let today = new Date()
      this.endDate = new Date()
      let oneMonthBack = new Date(today.setDate(today.getDate() - 31))
      this.startDate = oneMonthBack
    },
    getDate (theDate) {
      let formattedDate = moment(theDate).utc().format('YYYY-MM-DD')
      return formattedDate
    },
    getTotalWait (start, end) {
      const wait = (moment(end).diff(moment(start)))
      let mins = Math.floor(moment.duration(wait).asMinutes())
      if (isNaN(mins)) {
        return '-'
      }
      return mins
    },
    setTotalMins (start, end) {
      if (start !== '' && end !== '') {
        const wait = (moment(end).diff(moment(start)))
        let mins = Math.floor(moment.duration(wait).asMinutes())
        this.totalMins = this.totalMins + mins
      }
    },
    getTotalTime (mins) {
      let totalHours = Math.floor(mins / 60)
      let totalMins = Math.floor(mins - totalHours * 60)
      if (totalMins.toString().length < 2) {
        totalMins = '0' + totalMins
      }
      let total = totalHours + ':' + totalMins
      return total
    },
    getSelectedTotal () {
      let totalMins = 0
      for (let order of this.selectedOrders) {
        if (order.startWait !== '' && order.endWait !== '') {
          const wait = (moment(order.endWait).diff(moment(order.startWait)))
          totalMins = totalMins + Math.floor(moment.duration(wait).asMinutes())
        }
      }
      return this.getTotalTime(totalMins)
    },
    sortByName (a, b) {
      return a.data.regnbr.localeCompare(b.data.regnbr)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Statistics/WaitStats.vue